<template>
  <ul class="list-group profile-settings-menu border-divider rounded-0">
    <li class="list-group-item justify-content-between align-items-center">
      <span class="pr-2">{{ $t("Data") }}</span>
      <b-dropdown size="sm" class="dropdown-language-group" right toggle-class="text-uppercase dropdown-toggle-group mono" data-cy="app-settings-data-lang-ddn">
        <template #button-content>
          <span class="button-content">{{ getLanguageDisplayText(contentLanguages.enabled[0]) }}</span>
        </template>
        <b-dropdown-item
          href="#"
          v-for="locale in localizedLanguages"
          :key="locale.code"
          @click.prevent="tryChangeContentLanguages(0, locale)"
          :active="dataLanguage == locale.languageCode">
          {{ `${locale.localizedName} (${locale.languageCode})` }}
        </b-dropdown-item>
      </b-dropdown>
    </li>
    <li class="list-group-item justify-content-between align-items-center" v-for="(lang, index) in contentLanguages.enabled.slice(1)" :key="index">
      <span class="pr-2">{{ $t("DataTranslation") }}</span>
      <b-dropdown size="sm" class="dropdown-language-group" right toggle-class="mono text-uppercase dropdown-toggle-group" data-cy="app-settings-data-lang-ddn">
        <template #button-content>
          <span class="button-content">{{ getLanguageDisplayText(lang) }}</span>
        </template>
        <b-dropdown-item href="#" @click.prevent="tryChangeContentLanguages(index + 1, null)" class="text-dark" :active="translatedLanguage == 'none'">{{
          $t("none")
        }}</b-dropdown-item>
        <b-dropdown-item
          href="#"
          v-for="locale in availableLanguagesForTranslation"
          :key="locale.code"
          :active="translatedLanguage == locale.languageCode"
          @click.prevent="tryChangeContentLanguages(index + 1, locale)">
          {{ `${locale.localizedName} (${locale.languageCode})` }}
        </b-dropdown-item>
      </b-dropdown>
    </li>
    <li class="list-group-item justify-content-between align-items-center" v-if="contentLanguages.enabled.length < 2">
      <span class="pr-2">{{ $t("DataTranslation") }}</span>
      <b-dropdown
        class="dropdown-language-group"
        :text="$t('none')"
        size="sm"
        right
        toggle-class="mono text-uppercase dropdown-toggle-group"
        data-cy="app-settings-data-lang-ddn">
        <b-dropdown-item href="#" @click.prevent="tryChangeContentLanguages(1, null)" class="text-dark" :active="translatedLanguage == 'none'">{{
          $t("none")
        }}</b-dropdown-item>
        <b-dropdown-item
          href="#"
          v-for="locale in availableLanguagesForTranslation"
          :key="locale.code"
          @click.prevent="tryChangeContentLanguages(1, locale)"
          :active="translatedLanguage == locale.languageCode">
          {{ `${locale.localizedName} (${locale.languageCode})` }}
        </b-dropdown-item>
      </b-dropdown>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userSettings"]),
    ...mapState("metadata", ["contentLanguages", "localizedLanguages"]),
    ...mapGetters("metadata", ["hasAnyUnsavedData"]),
    availableLanguagesForTranslation() {
      return this.localizedLanguages.filter((lang) => this.contentLanguages.enabled[0].languageId != lang.languageId);
    },
    translatedLanguage() {
      return this.contentLanguages.enabled[1] ? this.contentLanguages.enabled[1].languageCode : "none";
    },
    dataLanguage() {
      return this.contentLanguages.enabled[0].languageCode;
    }
  },
  methods: {
    ...mapActions("metadata", ["changeContentLanguages", "loadLocalizedLanguages"]), //meta.language.translations
    tryChangeContentLanguages(index, locale) {
      if (this.hasAnyUnsavedData) {
        if (!confirm(this.$t("confirmNavigation"))) {
          return;
        }
      }

      if (index == 0) {
        const i = this.contentLanguages.enabled.findIndex((x) => x.languageId == locale.languageId);
        if (i > 0)
          this.changeContentLanguages({
            index: i,
            value: null
          });
      }

      const lang = !locale ? null : this.contentLanguages.available.find((x) => x.languageId == locale.languageId);
      this.changeContentLanguages({
        index: index,
        value: lang
      });
    },
    setLocalizedLanguages: function (languageCode) {
      this.loadLocalizedLanguages(languageCode);
    },
    getLanguageDisplayText(lang) {
      if (lang) {
        const displayLang = this.localizedLanguages?.find((x) => x.languageCode == lang.languageCode);
        return !displayLang ? this.$t("none") : `${displayLang.localizedName || ""} (${displayLang.languageCode})`;
      }

      return this.$t("none");
    }
  },
  watch: {
    "userSettings.CurrentLocale": {
      immediate: true,
      handler(nv) {
        this.setLocalizedLanguages(nv);
      }
    },
    "contentLanguages.available": {
      handler() {
        this.setLocalizedLanguages(this.userSettings.CurrentLocale);
      }
    }
  }
};
</script>
